import {
  usePaginatedResource,
  useResourceItem,
  useCreateResource,
  useEditResource,
  useDeleteResource,
} from "./useCrudResource"

import {
  getAccountBankAccountList,
  getAccountBankAccountById,
  createAccountBankAccount,
  updateAccountBankAccount,
  deleteAccountBankAccount,
} from "api/accountBankAccountApi"

export const ACCOUNT_BANK_ACCOUNT_QUERY_KEY = "account-bank-account"

export const useAccountBankAccounts = (params = {}, enabled = true) => {
  return usePaginatedResource(
    ACCOUNT_BANK_ACCOUNT_QUERY_KEY,
    getAccountBankAccountList,
    params,
    enabled
  )
}

export const useAccountBankAccount = (id, enabled = true) => {
  return useResourceItem(
    ACCOUNT_BANK_ACCOUNT_QUERY_KEY,
    getAccountBankAccountById,
    id,
    enabled
  )
}

export const useCreateAccountBankAccount = () => {
  return useCreateResource(
    createAccountBankAccount,
    ACCOUNT_BANK_ACCOUNT_QUERY_KEY
  )
}

export const useEditAccountBankAccount = () => {
  return useEditResource(
    updateAccountBankAccount,
    ACCOUNT_BANK_ACCOUNT_QUERY_KEY
  )
}

export const useDeleteAccountBankAccount = () => {
  return useDeleteResource(
    deleteAccountBankAccount,
    ACCOUNT_BANK_ACCOUNT_QUERY_KEY
  )
}
